import React from 'react'
import { useNavigate } from 'react-router-dom';
import ImageWithBasePath from '../../../core/data/img/ImageWithBasePath';
import { all_routes } from '../../router/all_routes';
import { useSelector } from 'react-redux';
import { setStorageItem } from '../../../services/storage.service';

const ThankYou = ({ email, user }: any) => {
  const navigate = useNavigate();
  const route = all_routes;
  // const userDetail = useSelector((state: any) => state.user.userDetail);

  if (user) {
    setStorageItem("userData", JSON.stringify(user?.data));
    setStorageItem("token", user?.token);
  }


  const goToSubscriptionPlan = () => {
    // if (userDetail?.has_subscription) {
    navigate(route.pricing)
    // }
    // else {
    //   navigate(route.cmsPricing)
    // }
    // navigate('/auth/login', { state: { email, onBoarding: true } });
  };

  return (
    <div className="main-wrapper authendication-pages thankyou-page thankyou-screen">
      <div className="content">
        <div className="container wrapper no-padding">
          <div className="row no-margin vph-100">
            <div className="col-12 col-sm-12 col-lg-8 no-padding d-flex">
              <div className="banner-bg banner-bg-1 login">
                <div className="row h100">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <div className="row h-100">
                      <div className="col-md-12 h-100">
                        <img
                          src="/assets/img/authImg.jpg"
                          className="object-fit-cover img-fluid w-100"
                          alt="authImg"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-sm-12  col-lg-4 no-padding d-flex">
              <div className="dull-pg shadow-card w-100 d-flex">
                <div className="row no-margin d-flex align-items-center justify-content-center">
                  <div className="col-sm-10 col-md-10 col-lg-11 mx-auto">
                    <div className="shadow-card-inner">
                      <header className="text-center position-relative ">
                        <ImageWithBasePath
                          src="assets/img/check-image.png"
                          className="img-fluid"
                          alt="Logo"
                        />
                      </header>
                      <h2 className="text-center">
                        Account Registered Successfully
                      </h2>
                      <p className="text-center">
                        Redirecting you to the Subscription Plan.
                      </p>
                      <div className="tab-content" id="myTabContent">
                        <div
                          className="tab-pane fade show active"
                          id="user"
                          role="tabpanel"
                          aria-labelledby="user-tab"
                        >
                          <form>
                            <button
                              onClick={goToSubscriptionPlan}
                              type="submit"
                              className="btn primaryButton  btn-primary d-inline-flex justify-content-center align-items-center w-100 btn-block"
                            >
                              Go to Subscription Plan
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-arrow-right"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
                                />
                              </svg>
                            </button>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ThankYou


